module.exports = __webpack_public_path__ + "media/images/location_services_light-d055265ccaec99bf04fb72e0b745fd5e.svg";